import { STATUS } from '@jobseeker/common-core/constants';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_JOB_SERVICE}/mtags`
);

const getTags = async (path: string, queryParams = { char: '', categoryId: 0 }): Promise<any> => {
  try {
    const response: any = await axios.get(`${path}`, { params: queryParams });

    if (response[STATUS] === 200) {
      return response['data'];
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data.error.message,
        code: error.response?.data.error.statusCode,
      },
    };
  }
};

const tagService = {
  getTags,
};

export default tagService;
